// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"95f340e5","147":"5961762f","210":"e5b86ee0","318":"4ad6ab3b","472":"10d4c96f","807":"04592a3f","900":"ef1fc81b","932":"82daf77b"}[chunkId] + ".chunk.js";
};